import { render, staticRenderFns } from "./OrderDelivery.vue?vue&type=template&id=5854ee66"
import script from "./OrderDelivery.vue?vue&type=script&lang=js"
export * from "./OrderDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5854ee66')) {
      api.createRecord('5854ee66', component.options)
    } else {
      api.reload('5854ee66', component.options)
    }
    module.hot.accept("./OrderDelivery.vue?vue&type=template&id=5854ee66", function () {
      api.rerender('5854ee66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/chart/OrderDelivery.vue"
export default component.exports